import { Box, Divider, Grid, Typography } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import { useState } from 'react';
import ProgramMetrics from './ProgramMetrics';
import PageWrapper from 'components/Common/PageWraper';

const AIMLOpsMetrics = () => {
	const theme = useTheme();
	const colors = theme.palette;
	const [activeTab, setActiveTab] = useState(0);

	const handleTabClick = (index: any) => {
		setActiveTab(index);
	};

	return (
		<PageWrapper>
			{/* Tab Navigation */}
			<Box
				px={{ xs: 1, md: 2, lg: 2 }}
				sx={{
					position: 'fixed',
					left: 75,
					right: 15,
					zIndex: 100,
					// top: 95 // TO-DO: rework on the layout to accomodate such secondary navbars instead of handling their styles under each page/component
				}}
			>
				<Grid container spacing={2}>
					<Grid item>
						<Box
							sx={{
								display: 'inline-block',
								color: activeTab === 0 ? 'textLight.secondary' : 'textLight.dark',
								cursor: 'pointer'
							}}
							onClick={() => handleTabClick(0)}
						>
							<Typography
								variant="tabLabel"
								sx={{ borderBottom: activeTab === 0 ? `4px solid ${colors.text.focus}` : 'none' }}
							>
								AI Ops Metrics
							</Typography>
						</Box>
					</Grid>
					<Grid item>
						<Box
							sx={{
								display: 'inline-block',
								color: activeTab === 1 ? 'textLight.secondary' : 'textLight.dark',
								cursor: 'pointer'
							}}
							onClick={() => handleTabClick(1)}
						>
							<Typography
								variant="tabLabel"
								sx={{ borderBottom: activeTab === 1 ? `4px solid ${colors.text.focus}` : 'none' }}
							>
								ML Ops Metrics 
							</Typography>
						</Box>
					</Grid>
				</Grid>

				<Divider sx={{ bgcolor: 'text.focus', mb: 2, mt: 0.5 }} />
			</Box>

			{/* Tab Content */}
 {/* * FIX:
              * 1. Removed `overflowY: 'auto'` to prevent the nested scroll container.
              * 2. Changed `mt: 4` to `mt: 10` (80px) to provide enough space for the 
              * fixed tabs + the 60px margin from the ProgramMetrics component.
            */}
            <Box sx={{ mt: 10 }}>				{activeTab === 0 && <ProgramMetrics metricsType={"AI Ops"} technologyLabel= {"Technology"} chartLabel= {"Technologies"} showSectorFilter={true}/>}
				{activeTab === 1 && <ProgramMetrics metricsType={"ML Ops"} technologyLabel= {"Technology"} chartLabel= {"Technologies"} showSectorFilter={true}/>}
			</Box>
		</PageWrapper>
	);
};

export default AIMLOpsMetrics;
